"use client"

import { ScrollToTopButton } from "@/components/ScrollToTopButton"
import { WhatsAppButton } from "@/components/WhatsAppButton"

export function FloatingActionButtons() {
  return (
    <div className="fixed bottom-6 right-6 z-50 flex flex-col items-end gap-3">
      <WhatsAppButton />
      <ScrollToTopButton />
    </div>
  )
}
